
import { connect } from 'react-redux';
import { compose } from 'redux';

import { fetchProducts, setTargetPlanPeriodicity } from '../actions/products';
import {
  doCreateSubscription,
  doDisplaySubscriptionGreeting,
} from '../actions/subscriptions';

import ProductPage from '../components/products/ProductPage';
import { withAllProducts } from './withAllProducts';
import { withCurrentUser } from './withUser';
import { withNavigation } from '../actions/navigation';

/**
 * Product Page
 * Takes product ID from URL param
 * Responsible for fetching all product related data
 * (licences, subscriptions, invitations)
 */

const makeCreateDefaultSubscription = (dispatch, {navigateToSubscription}) => 
({ account, product, licencesCount }) => 
  // creates a subscription
  dispatch(doCreateSubscription(account.id, product.id, product.trialPlan, licencesCount))
    .then( ({subscription}) => {
      if( subscription ) {
        // then navigate to subscription page 
        navigateToSubscription(subscription.id);
        dispatch( doDisplaySubscriptionGreeting(subscription.id) );
      }
    });

const mapStateToProps = ({productsById, creatingSubscription, planTargetPeriodicity}, {productId, account}) => {

  const product = productsById[productId];

  // FIXME: dirty
  const notFound = Object.keys(productsById).length > 0 && !product;

  return {
    product,
    account,
    notFound,
    planTargetPeriodicity,
    isCreatingSubscription: creatingSubscription
  }
};

const mapDispatchToProps = (dispatch, {navigateToSubscription}) => {
  
  return {
    loadData: () => {
      dispatch(fetchProducts());
    },  
    handleTrial: makeCreateDefaultSubscription(dispatch, {
      navigateToSubscription,
    }),
    handlePlanTargetPeriodicity: (periodicity) => {
      dispatch(setTargetPlanPeriodicity(periodicity));
    },  
  }
}

export default compose(
  withAllProducts,
  withCurrentUser,
  withNavigation,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(
  ProductPage
)


// WEBPACK FOOTER //
// ./src/containers/ProductPage.js